module.exports = "<div>\n  <i class=\"{{iconID}}\"></i>\n</div>\n"